import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { CloseIcon } from "./internal.js";
import { rendersNativeButton } from "../internal/nativeButton.js";
import { DialogRoot } from "../vendor/@base-ui/react/dialog/root/DialogRoot.js";
import { DialogTrigger } from "../vendor/@base-ui/react/dialog/trigger/DialogTrigger.js";
import { DialogPortal } from "../vendor/@base-ui/react/dialog/portal/DialogPortal.js";
import { DialogBackdrop } from "../vendor/@base-ui/react/dialog/backdrop/DialogBackdrop.js";
import { DialogPopup } from "../vendor/@base-ui/react/dialog/popup/DialogPopup.js";
import { DialogDescription } from "../vendor/@base-ui/react/dialog/description/DialogDescription.js";
import { DialogClose } from "../vendor/@base-ui/react/dialog/close/DialogClose.js";
import { DialogTitle } from "../vendor/@base-ui/react/dialog/title/DialogTitle.js";
const ModalFrame = React.forwardRef(function ModalFrame2({
  surfaceClass,
  title,
  description,
  children,
  footer,
  trigger,
  open,
  defaultOpen,
  onOpenChange,
  onOpenChangeComplete,
  closeOnEscape = true,
  closeOnOutsidePress = true,
  showCloseButton = true,
  closeLabel = "Close",
  initialFocus,
  finalFocus,
  container,
  className,
  id
}, ref) {
  const handleOpenChange = (nextOpen, details) => {
    if (!nextOpen) {
      const blocked = details.reason === "escape-key" && !closeOnEscape || details.reason === "outside-press" && !closeOnOutsidePress;
      if (blocked) {
        details.cancel();
        return;
      }
    }
    onOpenChange?.(nextOpen, details);
  };
  const heading = /* @__PURE__ */ jsx(DialogTitle, { children: title });
  return /* @__PURE__ */ jsxs(
    DialogRoot,
    {
      open,
      defaultOpen,
      onOpenChange: handleOpenChange,
      onOpenChangeComplete,
      disablePointerDismissal: !closeOnOutsidePress,
      modal: true,
      children: [
        trigger ? /* @__PURE__ */ jsx(DialogTrigger, { render: trigger, nativeButton: rendersNativeButton(trigger) }) : null,
        /* @__PURE__ */ jsxs(DialogPortal, { container, children: [
          /* @__PURE__ */ jsx(DialogBackdrop, { className: "ev-scrim" }),
          /* @__PURE__ */ jsxs(
            DialogPopup,
            {
              ref,
              id,
              className: cx(surfaceClass, "ev-root", className),
              "aria-modal": "true",
              initialFocus,
              finalFocus,
              children: [
                /* @__PURE__ */ jsxs("div", { className: "ev-dialog__head", children: [
                  description != null && description !== false ? /* @__PURE__ */ jsxs("div", { className: "ev-dialog__heading", children: [
                    heading,
                    /* @__PURE__ */ jsx(DialogDescription, { className: "ev-dialog__desc", children: description })
                  ] }) : heading,
                  showCloseButton ? /* @__PURE__ */ jsx(DialogClose, { className: "ev-btn ev-btn--ghost ev-btn--icon", "aria-label": closeLabel, children: /* @__PURE__ */ jsx(CloseIcon, {}) }) : null
                ] }),
                /* @__PURE__ */ jsx("div", { className: "ev-dialog__body", children }),
                footer != null && footer !== false ? /* @__PURE__ */ jsx("div", { className: "ev-dialog__foot", children: footer }) : null
              ]
            }
          )
        ] })
      ]
    }
  );
});
ModalFrame.displayName = "ModalFrame";
export {
  ModalFrame
};
//# sourceMappingURL=ModalFrame.js.map
